/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */
import * as styles from '../styles/Header.module.scss';

type HeaderProps = {
  title: string;
  description?: string;
};

export const Header = ({title, description}: HeaderProps) => {
  return (
    <div className={styles.container}>
      <h1 id={styles.title}>{title}</h1>
      {description && <p id={styles.description}>{description}</p>}
    </div>
  );
};
